import { dispatcher, api } from 'react-structure-admin';

export const HEALTHSERVICEPROVIDER = 'HEALTHSERVICEPROVIDER';

export const HEALTHSERVICEPROVIDER_GET_CURRENT =
  'HEALTHSERVICEPROVIDER_GET_CURRENT';
export const HEALTHSERVICEPROVIDER_GET_CURRENT_FINISHED =
  'HEALTHSERVICEPROVIDER_GET_CURRENT_FINISHED';

export const HEALTHSERVICEPROVIDER_PUT_CURRENT =
  'HEALTHSERVICEPROVIDER_PUT_CURRENT';
export const HEALTHSERVICEPROVIDER_PUT_CURRENT_FINISHED =
  'HEALTHSERVICEPROVIDER_PUT_CURRENT_FINISHED';

export const HEALTHSERVICEPROVIDER_CANCEL_CURRENT =
  'HEALTHSERVICEPROVIDER_CANCEL_CURRENT';

export const HEALTHSERVICEPROVIDER_AVAILABILITY_FETCH =
  'HEALTHSERVICEPROVIDER_AVAILABILITY_FETCH';
export const HEALTHSERVICEPROVIDER_AVAILABILITY_FETCH_FINISHED =
  'HEALTHSERVICEPROVIDER_AVAILABILITY_FETCH_FINISHED';

export const fetchAvailability = (
  serviceProviderId,
  startDate,
  endDate
) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'health-service-providers',
    actionType: HEALTHSERVICEPROVIDER_AVAILABILITY_FETCH,
    effect: async () =>
      api.fetch(`health-service-providers/:id/?:startDate&:endDate`, {
        startDate,
        endDate,
        serviceProviderId
      })
  });
};

export const getCurrentProfessional = () => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'health-service-providers',
    actionType: HEALTHSERVICEPROVIDER_GET_CURRENT,
    effect: async () =>
      api.get('health-service-providers', 'current-professional')
  });
};

export const updateCurrentProfessional = (data) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'health-service-providers',
    payload: data,
    actionType: HEALTHSERVICEPROVIDER_PUT_CURRENT,
    effect: async () =>
      api.put('health-service-providers/current-professional', data)
  });
};

export const cancelCurrentProfessional = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      HEALTHSERVICEPROVIDER_CANCEL_CURRENT,
      'health-service-providers'
    )
  );
};
